import { createAndAddGenericElement } from './generics.js'

const getCardHeading = index => `heading_${index+1}`
const getCollapseTitle = index =>  `collapse_${index+1}`
const getAccordionTitle = () => `accordion`

const createAccordionQuesButton = (quesContent, index, hideShowFirstQuesAns) => {
    let collapseText = "collapsed"
    if (hideShowFirstQuesAns && index === 0) collapseText = ""
    const faqQuesButton = createAndAddGenericElement(["btn", "btn-link", collapseText], "", "", quesContent, "button")
    faqQuesButton.setAttribute('data-toggle', `collapse`)
    faqQuesButton.setAttribute('data-target', `#${getCollapseTitle(index)}`)
    const trueOrFalse = (index) ? true : false
    faqQuesButton.setAttribute('aria-expanded', trueOrFalse)
    faqQuesButton.setAttribute('aria-controls', getCollapseTitle(index))
    return faqQuesButton
}

const createAccordionQues = (quesContent, index, alignButtonTextCenter, hideShowFirstQuesAns) => {
    // create faq card-header
    const textCentered = (alignButtonTextCenter) ? "text-center" : ""
    const faqCardHeader = createAndAddGenericElement(["card-header", textCentered], "", "", "", "div")
    faqCardHeader.setAttribute('id', getCardHeading(index))
    // create h5 element
    const quesDivButton = createAccordionQuesButton(quesContent, index, hideShowFirstQuesAns)
    createAndAddGenericElement(["mb-0"], quesDivButton, faqCardHeader, "", "h5")
    return faqCardHeader
}

const createAccordionAnsContent = (answerText) => {
    const para = document.createElement('div')
    if(answerText.bold) {
        para.innerHTML = '<strong>' + answerText.para + '</strong>'
    } else if (answerText.items) {
        const ul = createAndAddGenericElement(["ml-5"], "", "", "", "ul")
        for(let j = 0; j < answerText.items.length; ++j) {
            createAndAddGenericElement([""], "", ul, answerText.items[j], "li")     // create li
        }
        para.appendChild(ul)
    } 
    else {
        para.innerHTML = answerText.para
    }
    return para
}

const createAccordionAws = (ansContent, index, hideShowFirstQuesAns) => {
    let showOrHide = ""
    if (hideShowFirstQuesAns && index === 0) showOrHide = "show"
    const faqAnsDiv = createAndAddGenericElement(["collapse", showOrHide], "", "", "", "div")
    faqAnsDiv.setAttribute('id', getCollapseTitle(index))
    faqAnsDiv.setAttribute('aria-labelledby', getCardHeading(index))
    faqAnsDiv.setAttribute('data-parent', `#${getAccordionTitle()}`)
    const cardBodyDiv = document.createElement('div')
    cardBodyDiv.classList.add("card-body")
    for(let i = 0; i < ansContent.length; ++i) {
        cardBodyDiv.appendChild( createAccordionAnsContent(ansContent[i]) )
    }
    faqAnsDiv.appendChild(cardBodyDiv)
    return faqAnsDiv
}

const createFaqCard = (faqQuesAns, index, alignButtonTextCenter, hideShowFirstQuesAns) => {
    // create faq card
    const faqCard = createAndAddGenericElement(["card"], "", "", "",  "div")
    const accordionQuesDiv = createAccordionQues(faqQuesAns.quest, index, alignButtonTextCenter, hideShowFirstQuesAns)
    faqCard.appendChild( accordionQuesDiv )
    const accordionAnsDiv = createAccordionAws(faqQuesAns.answer, index, hideShowFirstQuesAns)
    faqCard.appendChild( accordionAnsDiv )
    return faqCard
}

const createAccordionElem = (accordionList, parentElem, startIndex,  endIndex, alignButtonTextCenter, hideShowFirstQuesAns) => {
    const divAccordion = document.createElement('div')
    for (let i = startIndex; i < endIndex; ++i) {
        divAccordion.appendChild( createFaqCard(accordionList[i], i, alignButtonTextCenter, hideShowFirstQuesAns) )
    }
    divAccordion.setAttribute( 'id', getAccordionTitle() )
    parentElem.appendChild(divAccordion)
}
export { createAccordionElem }